module.exports = __webpack_public_path__ + "img/07_no.630962db.svg";